/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import type { LicenseObject } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'
import { CuiButtonEmpty } from '@modules/cui/Button'
import { CuiFileUploadButton } from '@modules/cui/FileUploadButton'
import PermissionsGate from '@modules/permissions-components/PermissionsGate'

import { readJson } from '../../../../lib/fileHelpers'

interface Props {
  addLicenseRequest: AsyncRequestState
  regionId: string
  setLicense: (regionId: string, licenseFromFile: LicenseObject) => void
}

interface State {
  file: File | null
}

class UpdateLicense extends Component<Props, State> {
  state: State = {
    file: null,
  }

  render() {
    const { addLicenseRequest } = this.props

    return (
      <PermissionsGate
        permissions={[
          {
            type: 'license',
            action: 'update',
          },
        ]}
      >
        {({ hasPermissions }) => (
          <CuiFileUploadButton
            disabled={addLicenseRequest.inProgress || !hasPermissions}
            onChange={this.uploadFile}
          >
            <CuiButtonEmpty
              disabled={!hasPermissions}
              iconType='importAction'
              color='primary'
              size='s'
              spin={addLicenseRequest.inProgress}
            >
              <FormattedMessage
                id='upload-license.update-license'
                defaultMessage='Upload new license'
              />
            </CuiButtonEmpty>
          </CuiFileUploadButton>
        )}
      </PermissionsGate>
    )
  }

  uploadFile = (file: File) => readJson(file).then(this.save)

  save = (licenseFromFile) => {
    const { regionId, setLicense } = this.props

    return setLicense(regionId, licenseFromFile)
  }
}

export default UpdateLicense
